import { render } from "./TestimonialsSection.vue?vue&type=template&id=7041156e&scoped=true"
import script from "./TestimonialsSection.vue?vue&type=script&lang=js"
export * from "./TestimonialsSection.vue?vue&type=script&lang=js"

import "./TestimonialsSection.vue?vue&type=style&index=0&id=7041156e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7041156e"]])

export default __exports__